import { CustomTable } from '@ui-kit'
import { APPLICATION_PREFERENCES, NAMESPACES } from '../../utils/constants'
import { DataTypeStore } from '@app-store'

export const AgentScheduleSettings = () => {
  const columns = [
    {
      header: 'Agent Name',
      type: 'hyperlink',
      accessor: 'agentName',
    },
    {
      header: 'Agent User ID',
      type: '',
      accessor: 'userId',
    },
    {
      header: 'Clients',
      type: '',
      accessor: 'clients',
    },
    {
      header: 'Shifts',
      type: '',
      accessor: 'shifts',
    },
  ]
  const actions = [
    {
      label: NAMESPACES.VIEW,
      key: 'view',
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
    },
    {
      label: NAMESPACES.EDIT,
      key: 'edit',
      showInPopUp: false,
      isEnabledOnDisabledRow: false,
    },
  ]
  return (
    <div className="flex w-full flex-col gap-3 font-primary">
      <div className="font-primary flex flex-col gap-3">
        <div className="font-medium text-base font-primary">
          {APPLICATION_PREFERENCES.AGENT_SCHEDULE_SETTINGS}
        </div>
        <div className=" font-primary font-light text-xs">
          {APPLICATION_PREFERENCES.AGENT_SCHEDULE_DESCRIPTION}
        </div>
      </div>
      <div className="shadow-lg rounded p-2">
        <CustomTable
          dataQaId="agent-schedule-settings-table"
          data={[{ agentName: 'agent' } as DataTypeStore]} //Note: Mock Data
          columns={columns}
          showTableColumnOnEmpty={true}
          actions={actions}
        />
      </div>
    </div>
  )
}
